import { render, staticRenderFns } from "./TraditionDrug.vue?vue&type=template&id=049b3339&scoped=true"
import script from "./TraditionDrug.vue?vue&type=script&lang=js"
export * from "./TraditionDrug.vue?vue&type=script&lang=js"
import style0 from "./TraditionDrug.vue?vue&type=style&index=0&id=049b3339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b3339",
  null
  
)

export default component.exports